import { formatResultValue } from "../utils/numericUtils";

const Result = ({ title, value }) => (
    <div className="result-panel">
        <div className="result-title">{title}</div>
        <div className="result-value">{value}</div>
    </div>
);

export default function Results({ result }) {
    if (!result || Object.keys(result).length === 0) return null;

    return (
        <>
            <Result
                title="Total Embedded Emissions (tCO₂)"
                value={formatResultValue(result.total_embedded, { isAmount: true })}
            />
            <Result
                title="Number of Certificates (tCO₂)"
                value={formatResultValue(result.certificates, { isAmount: true })}
            />
            <Result
                title="EU-CBAM Payment (€)"
                value={formatResultValue(result.payment, { isPrice: true })}
            />
            <div className="divider padding_double"></div>
        </>
    );
}
